// Check localStorage.getItem('adBlockDetected') before making this call
export const checkForRedirect = (location) => {
  if (location.pathname.indexOf("advertisers") > -1) {
    window.location.replace("/")
    window.localStorage.setItem("showAdBlockPopup", "true");
    return false;
  }
  return true;
}
